<div class="modal-body p-0">
  <div class="container-fluid applicaiton-popup">
    @if (screen === 'businessobjectives') {
      <div class="back d-flex" (click)="backToObjective()">
        Back to <span [innerHTML]="selectedObjective.title"></span>
      </div>
    }
    <div class="">
      <!-- accordion 1 -->
      <div class="accordion mb-3" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button bg-info1 text-white fs-18 fw-bold" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              APPLICATION DATA
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="row mb-34">
                <div class="col-lg-6">
                  <div class="uniquie-id height-align d-flex justify-content-between">
                    <div>
                      <p class="fs-13 text-info2 fw-500 mb-1">UNIQUE ID</p>
                      <p>{{ appData.appID }}</p>
                    </div>
                    <div class="d-flex image">
                      <img [src]="appPic" class="image" appImageFallback
                        [fallbackSrc]="'../../../assets/images/public/applicationdatadefault.jpeg'" />
                      <div class="add-uni-fata">
                        <h6>FA</h6>
                        <h6 [style.color]="
                                getFATAColor(appData.faQusAvg)
                              ">
                          {{ appData.faQusAvg }}
                        </h6>
                      </div>
                      <div class="add-uni-fata">
                        <h6>TA</h6>
                        <h6 [style.color]="
                                getFATAColor(appData.taQusAvg)
                              ">
                          {{ appData.taQusAvg }}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="form-floating text-dark mb-34">
                      <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION NAME</p>
                      <p>{{ appData.appName }}</p>
                    </div>
                  </div>
                  <div class="mb-3">
                    <p class="fs-13 text-info2 fw-500 mb-1">DESCRIPTION</p>
                    <p>{{ appData.desc }}</p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">HOSTING LOCATION</p>
                        <p>{{ appData.location }}</p>
                      </div>
                      <div class="text-dark mb-34">
                        <p-floatlabel>
                          <p class="fs-13 text-info2 fw-500 mb-1">BUSINESS CRITICALITY</p>
                          <p>{{ appData.criticality }}</p>
                        </p-floatlabel>
                      </div>
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION OWNER</p>
                        <p>{{ appData.owner }}</p>
                      </div>
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION TYPE</p>
                        <p>{{ appData.type }}</p>
                      </div>
                      <div class="text-dark mb-34">
                        <p-floatlabel>
                          <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION TCO (<span
                          [innerHTML]="company ? company.curr : ''"></span>)</p>
                          <p>{{ appData.tco }}</p>
                        </p-floatlabel>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">GEOGRAPHIC COVERAGE</p>
                        <p>{{ appData.coverage }}</p>
                      </div>
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION CATEGORY</p>
                        <p>{{ appData.category }}</p>
                      </div>
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION MANUFACTURER</p>
                        <p>{{ appData.provider }}</p>
                      </div>
                      <div class="form-floating text-dark mb-34">
                        <p class="fs-13 text-info2 fw-500 mb-1">APPLICATION STATUS</p>
                        <p>{{ appData.status }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <p class="fs-20 text-info2 fw-500 border-bottom">
                  CUSTOM FIELDS
                </p>
                @for (
                  customFields of appData.categories
                  ; track
                  customFields) {
                  <div class="col-lg-6 col-xl-3">
                    <div class="text-dark mb-34 text-caps">
                      <p-floatlabel>
                        <!-- <p-select
                        inputId="type"
                        [options]="getOptions(customFields?._id)"
                        [(ngModel)]="customFields.value"
                        placeholder="Select any one"
                        [editable]="true"
                        >
                      </p-select> -->
                      <!-- <p for="type">{{ customFields?.label }}</p> -->
                      <p class="fs-13 text-info2 fw-500 mb-1">{{customFields?.label}}</p>
                      <p>{{ customFields.value || '-' }}</p>
                    </p-floatlabel>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid p-3">
      <app-mapping-card-popup
        [context]="'application'"
        [currentSelectedItem]="appData"
        [strategyId]="appService.currentActivatedFeature.strategyId"
        [showButtons]="false"
        (mappingsChange)="onMappingsChange($event)">
      </app-mapping-card-popup>
    </div>
  </div>
</div>

</div>